import { SocialTab } from '@/models/Social/Profile/social-tab';
import { SocialLikes, SocialLikesType } from '@/models/Social/social-likes';
import { SocialTabBlocks } from '@/models/Social/Profile/social-tab-blocks';
import { SocialTabQuestions } from '@/models/Social/Profile/social-tab-questions';
import { SocialTabProducts } from '@/models/Social/Profile/social-tab-products';
import { SocialTabTemplates } from '@/models/Social/Profile/social-tab-templates';
import { BlockFactory } from "@/models/Blocks/Itens/block-factory";
import { TemplateItemType } from '@/models/Blocks/Itens/Types/template-item-type';
import { BlockItem } from '@/models/Blocks/Itens/block-item';

export class SocialProfile {
    protected _id?: number|string;
    protected _name?: string;
    private _nameId: string;
    protected _description?: string;
    private _isVerified: boolean = false;
    protected _img?: string; // main
    protected _galleryImages?: Array<Object>;
    protected _tabs: Array<SocialTab> = [];
    protected _publications: number = 0;
    protected _likes: SocialLikes = new SocialLikes(0,false);
    protected _url?: string;
    private _shareOtLink?: string;
    protected _ot?: string;
    /*protected _couponDescription?: string;
    protected _couponCode?: string;
    protected _percentageOff?: string;*/
    protected _couponStruct?: BlockItem;
    protected _socialNetwork?: string;
    protected _isMobile: boolean = true;
    protected _hasChat: boolean = false;
    protected _productsMub?: object;
    protected _blocksColor?: string;
    protected _type?: string;
    private _replyTime?: string;
    private _location?: string;
    private _professionDescription?: string;

    public constructor(id?: number|string, name?: string, url?: string) {
        this._id = id;
        this._name = name;
        this._url = url;
        this._nameId = '';
    }

    public get id(): number|string|undefined { return this._id; }
    public get name(): string|undefined { return this._name;}


    public get nameId(): string { return this._nameId; }

    public set nameId(value: string) { this._nameId = value; }

    public get url(): string|undefined { return this._url; }

    //OT (Origem Trafego)
    public get ot(): string|undefined { return this._ot; }
    public set ot(value: string|undefined) { this._ot = value;}


    public get shareOtLink(): string { return this._shareOtLink;}
    public set shareOtLink(value: string) { this._shareOtLink = value;}

//Description
    public get description(): string|undefined { return this._description; }
    public set description(value: string|undefined) { this._description = value;}

    public get isVerified(): boolean {return this._isVerified;}
    public set isVerified(value: boolean) {this._isVerified = value;}

//Followers
    public get followers(): number { return this._likes.num;}
    public set followers(value: number) { this._likes.num = value;}

    //Followers Formated
    public get followersFormatted(): string|undefined { return this._likes.numFormatted;}
    public set followersFormatted(value: string|undefined) { this._likes.numFormatted = value;}

    //Publications
    public get publications(): number { return this._publications;}
    public set publications(value: number) { this._publications = value; }

    //Profile image
    public get image(): string|undefined { return this._img; }
    public set image(value: string|undefined) { this._img = value; }

    public get galleryImages(): Array<Object>|undefined { return this._galleryImages; }
    public set galleryImages(value: Array<Object>|undefined) { this._galleryImages = value; }

    public get type(): string | undefined {return this._type;}
    public set type(value: string) {this._type = value; }

    public get hasChat(): boolean {return this._hasChat;}

    public set hasChat(value: boolean) {this._hasChat = value;}

//Follow
    public get following(): boolean { return this._likes.liked; }
    public set following(value: boolean) { this._likes.liked = value; }

    //Like 
    public get like(): SocialLikes { return this._likes; }
    public set like(value: SocialLikes) { this._likes = value; }

    //Promo for coupon
    public get promo(): BlockItem|undefined { return this._couponStruct; }
    public set promo(value: BlockItem|undefined) { this._couponStruct = value;}

    /*
    //Coupon Description
    public get couponDescription(): string|undefined { return this._couponDescription; }
    public set couponDescription(value: string|undefined) { this._couponDescription = value;}

    //Coupon Code
    public get couponCode(): string|undefined { return this._couponCode; }
    public set couponCode(value: string|undefined) { this._couponCode = value;}

    //Percentage Off
    public get percentageOff(): string|undefined { return this._percentageOff; }
    public set percentageOff(value: string|undefined) { this._percentageOff = value;}
    */

    //Social Network
    public get socialNetwork(): string|undefined { return this._socialNetwork; }
    public set socialNetwork(value: string|undefined) { this._socialNetwork = value;}

    public get isMobile(): boolean { return this._isMobile; }
    public set isMobile(value: boolean) { this._isMobile = value;}

    // products OTI key
    public get productsMub(): object|undefined { return this._productsMub; }
    public set productsMub(value: object|undefined) { this._productsMub = value;}

    public get blocksColor(): string { return this._blocksColor; }

    public set blocksColor(value: string) { this._blocksColor = value; }


    public get replyTime(): string { return this._replyTime; }

    public set replyTime(value: string) { this._replyTime = value; }

    public get location(): string { return this._location; }

    public set location(value: string) { this._location = value; }


    public get professionDescription(): string { return this._professionDescription; }

    public set professionDescription(value: string) { this._professionDescription = value; }

    /**
     * Add a new tab to profile
     * 
     * @param value 
     */
    public addTab(value:SocialTab) {
        this._tabs.push(value);
    }

    /**
     * Return the profile tabs
     */
    public get tabs(): Array<SocialTab> { return this._tabs; }

    /**
     * Create a new profile backend values 
     * 
     * @param values 
     * @param contentUrl 
     * @returns SocialProfile
     */
    public static create(values: any, contentUrl: string, isMobile: boolean = true): SocialProfile|undefined{
        if (!values || !values.id || !values.name) {
            return undefined;
        }
        let p = new SocialProfile(values.id, values.name, (values.url ?? undefined));
        p.description        = values.description ?? "";
        p.isVerified         = values.isVerified ?? false;
        p.publications       = values.publications ?? 0;
        p.image              = values.image ?? undefined;
        p.galleryImages      = values.galleryImages ?? undefined;
        p.ot                 = values.ot ?? undefined;
        p.shareOtLink                 = values.shareOtLink ?? undefined;
        p.like               = new SocialLikes(values.followers ?? 0,values.following ?? false);
        if(values.followersFormated ?? null) {
            p.like.numFormatted = values.followersFormated;
        }
        p.like.id            = values.id ?? undefined;
        p.like.type          = SocialLikesType.PROFILE;
        //p.couponDescription  = values.couponDescription ?? "";
        //p.couponCode         = values.couponCode ?? "";
        //p.percentageOff      = values.percentageOff ?? "";
        if(values.promoCoupon ?? null) {
            p.promo = BlockFactory.get(values.promoCoupon)??undefined;
            p.promo && (p.promo.templateType = TemplateItemType.horizontal)
        }
        p.socialNetwork      = values.socialNetwork ?? "";
        p.isMobile           = isMobile;
        p.productsMub        = values.productsMub ?? null;
        p.blocksColor        = values.blocksColor ?? '#28ACB5';
        p.nameId             = values.nameId ?? '';
        p.type               = values.type ?? 'promoter';
        p.hasChat            = values.hasChat ?? false;
        p.replyTime          = values.replyTime ?? '';
        p.location           = values.location ?? '';
        p.professionDescription = values.professionDescription ?? '';
        //Tabs
        if (values.tabs ?? null) {
            values.tabs.forEach((tab: any) => {
                let name = tab.name ?? '';
                let active = tab.active ?? false;
                let params = tab.params ?? {};
                let selected = tab.selected ?? false;
                let tabObj = null;
                if (active) {
                    switch (tab.type ?? '') {
                        case 'BLOCKS':
                            tabObj = isMobile ? new SocialTabBlocks(name, params, contentUrl, isMobile) : new SocialTabTemplates(name, params, contentUrl);
                            break;
                        case 'DIALOG':
                            tabObj = new SocialTabQuestions(name, params, contentUrl);
                            break;
                        case 'PRODUCTS':
                            tabObj = isMobile ? new SocialTabProducts(name, params, contentUrl) : new SocialTabTemplates(name, params, contentUrl);
                            break;
                    }
                    if (tabObj) {
                        tabObj.selected = selected;
                        p.addTab(tabObj);
                    }
                }
            });
        }
        return p;
    }
}